import { render, staticRenderFns } from "./EditPlant.vue?vue&type=template&id=07f8db32&scoped=true&"
import script from "./EditPlant.vue?vue&type=script&lang=js&"
export * from "./EditPlant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8db32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
